import "./PatientGallery.module.css";
import Header from "@/reusable_sections/Header";
import TheFacesOfCityPetCare from "./sections/TheFacesOfCityPetCare";
import ShareYourPetSStory from "./sections/ShareYourPetSStory";
import Footer from "@/reusable_sections/Footer";
export default function PatientGalleryPage() {
  return <div>
      <Header />
      <TheFacesOfCityPetCare />
      <ShareYourPetSStory />
      <Footer />
    </div>;
}